import {Trans, useTranslation} from 'gatsby-plugin-react-i18next';

const SecurityCompliance = () => {
    const { t } = useTranslation();
    return (
    <>
        <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 scomp-1">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12 col-sm-8 col-md-8 col-lg-8">
                    <h1 className="font-weight-semibold hero-heading mt-5 no-br">
                        <Trans>Safety First: <br/>Preserving Data <br/>Privacy</Trans>
                    </h1>
                    <p className="hero-para font-weight-semibold no-br">
                        <Trans>Employee data protection is our utmost priority.</Trans>
                    </p>
                    <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Learn More</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="">
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-5">
                            <div className="col-12">
                                <div className="features-label red-font no-br">
                                    <Trans>Ensured Data Security</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading no-br'><Trans>Secured<br/> Data Hosting</Trans></h2>
                                <p className='section-para font-weight-normal'><Trans>Your employee data finds a secure home in a dedicated data center within your region, ensuring a trusted and localized approach to your corporate wellness journey.</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-7 cta-img'>
                            <div className='d-flex justify-content-center'>
                                <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1728456872/VantageFit/2024/image" fetchPriority="high" alt="Secured Data Hosting" width="500" height="518"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex flex-row-reverse m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-6">
                            <div className="col-12">
                                <div className="features-label green-font">
                                    <Trans>Confidentiality Assured</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading no-br'><Trans>No External<br/> Sharing of PII</Trans></h2>
                                <p className='section-para font-weight-normal no-br'><Trans>With Vantage Fit, Personal Identifiable Information (PII) are closely guarded. <br/><br/>We guarantee that your employee data remains strictly within our secure ecosystem, never shared with third parties.</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-6 cta-img'>
                            <div className='col-12 d-flex justify-content-center'>
                                <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1701166432/VantageFit/2023/Vfit-security-Confidentiality" loading='lazy' alt="No External Sharing of PII" width="500" height="500"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-5">
                            <div className="col-12">
                                <div className="features-label orange-font">
                                    <Trans>Upholding HIPAA Guidelines</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading no-br'><Trans>Your Health<br/> Information Secure<br/> and Private</Trans></h2>
                                <p className='section-para font-weight-normal'><Trans>At Vantage Fit, we follow HIPAA guidelines, securing and respecting the privacy of your employees' health information for a reassuring wellness journey.</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-7 cta-img'>
                            <div className='d-flex justify-content-center'>
                                <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1701166423/VantageFit/2023/Vfit-security-Upholding_HIPAA_Guidelines" loading='lazy' alt="Your Health Information Secure and Private" width="500" height="497"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="section-heading-top cursive">
                <h2 className="section-heading font-weight-bold text-center mb-4"><Trans i18nKey="subtextfeat11">Our Pledge to your&nbsp;<span className="charmonman green-clr">Data's security</span></Trans>&nbsp;!</h2>
                <div className="section-para text-center"><Trans>Ensure the safety of your employee data with our meticulous security measures in place.</Trans></div>
            </div>
        </section>

        <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center no-br">
                        <Trans>Learn More About our Security Measures!</Trans>
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5 text-white">
                        <Trans>Discover how we ensure data remains safe and confidential.</Trans>
                    </p>
                    <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </>
  )
}

export default SecurityCompliance
